import { switchMap } from "rxjs/operators";

import { TranslationDataStore } from "@skinsoft/entity";
import { fetchAllLocales } from "@skinsoft/i18n/src/fetch-locale";

declare const config
const AVAILABLE_LOCALES: string[] = config.availableLocales

export async function initLanguages() {
    TranslationDataStore.getInstance().getAllAvailableLanguages(AVAILABLE_LOCALES).pipe(
        switchMap(locales => {
            return fetchAllLocales(locales)
        })
    )
    .subscribe()
}